/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssigneeCandidateDto,
  CalculationSettingsDto,
  CalculationSettingsFileProcessResultResponse,
  CalculationSettingsRequestBody,
  CalculationSettingsTemplateDownloadRequest,
  ConvertVersionRequestBody,
  CopyPricePreviewResponse,
  CopyPriceRequest,
  CopyPriceResponse,
  CreatePresignedUrlRequest,
  CreatePriceExperienceRequest,
  CreatePriceExperienceRowDto,
  CreatePriceMode,
  CreatePriceSessionResponse,
  CreatePriceValidationProblemDetails,
  DeleteNoveltyPricesRequest,
  DeleteNoveltyPricesResponse,
  DevAutoCalcLogDto,
  DevAutoCalcLogFilter,
  DevAutoCalcRunDto,
  DevEventInboxFilter,
  DevEventInboxMessageDto,
  DevIngestionStatusDto,
  DevOverviewDto,
  DevPriceRowDto,
  DevPriceRowFilter,
  DevSettingDto,
  DevTelemetryErrorDto,
  DevUserDto,
  FilteredListItem,
  GetCalculationSettingsUploadTargetsResponse,
  GetCalculationTypesResponse,
  GetDetailedSimulationResponse,
  GetKeyFiguresPreviousYearResponse,
  GetPresignedUrlRequestResponse,
  GetPriceSettingsResponse,
  GetSimulationResponse,
  GetTemplateResponse,
  HasPermissionResponse,
  LoadLelRrpPricesResponse,
  MigrateContactsRequest,
  NoveltyCalcRequest,
  NoveltyCalcResponse,
  PriceEventQueueStatusResponse,
  PriceForProductDto,
  PricePointDto,
  PriceUnitCategoryDto,
  PriceUnitDto,
  ProblemDetails,
  ProductDto,
  PublishPricesRequestBody,
  RecordSimulationMismatchesRequestBody,
  RenameSimulationRequestBody,
  SaveCreatePriceRequest,
  SaveCreatePriceResponse,
  SaveCreatePriceSessionRequest,
  SaveNoveltyCalcRequestBody,
  SavePriceRowsRequestBody,
  SavePriceSettingsRequestBody,
  SimulationExcelFileNamesResponse,
  SimulationFieldExtractionResult,
  SimulationListEntryDto,
  SimulationOperationResult,
  SimulationStatus,
  StartSimulationRequestBody,
  StartSimulationResponse,
  SyncContactResponse,
  SyncTargetsToCalculationSettingsResult,
  TestResponse,
  TriggerAutoCalcResponse,
  UpdateDevSettingRequest,
  UpdateSimulationAssignmentRequestBody,
  UpdateWatchersRequestBody,
  UploadFileProcessResultResponse,
  UploadType,
  UserClaimsResponse,
  UserPermissionsResponse,
  UserWithEmailDto,
  ValidationProblemDetails,
  VersionEntryDto,
  WatcherDto,
} from '../models/index';
import {
    AssigneeCandidateDtoFromJSON,
    AssigneeCandidateDtoToJSON,
    CalculationSettingsDtoFromJSON,
    CalculationSettingsDtoToJSON,
    CalculationSettingsFileProcessResultResponseFromJSON,
    CalculationSettingsFileProcessResultResponseToJSON,
    CalculationSettingsRequestBodyFromJSON,
    CalculationSettingsRequestBodyToJSON,
    CalculationSettingsTemplateDownloadRequestFromJSON,
    CalculationSettingsTemplateDownloadRequestToJSON,
    ConvertVersionRequestBodyFromJSON,
    ConvertVersionRequestBodyToJSON,
    CopyPricePreviewResponseFromJSON,
    CopyPricePreviewResponseToJSON,
    CopyPriceRequestFromJSON,
    CopyPriceRequestToJSON,
    CopyPriceResponseFromJSON,
    CopyPriceResponseToJSON,
    CreatePresignedUrlRequestFromJSON,
    CreatePresignedUrlRequestToJSON,
    CreatePriceExperienceRequestFromJSON,
    CreatePriceExperienceRequestToJSON,
    CreatePriceExperienceRowDtoFromJSON,
    CreatePriceExperienceRowDtoToJSON,
    CreatePriceModeFromJSON,
    CreatePriceModeToJSON,
    CreatePriceSessionResponseFromJSON,
    CreatePriceSessionResponseToJSON,
    CreatePriceValidationProblemDetailsFromJSON,
    CreatePriceValidationProblemDetailsToJSON,
    DeleteNoveltyPricesRequestFromJSON,
    DeleteNoveltyPricesRequestToJSON,
    DeleteNoveltyPricesResponseFromJSON,
    DeleteNoveltyPricesResponseToJSON,
    DevAutoCalcLogDtoFromJSON,
    DevAutoCalcLogDtoToJSON,
    DevAutoCalcLogFilterFromJSON,
    DevAutoCalcLogFilterToJSON,
    DevAutoCalcRunDtoFromJSON,
    DevAutoCalcRunDtoToJSON,
    DevEventInboxFilterFromJSON,
    DevEventInboxFilterToJSON,
    DevEventInboxMessageDtoFromJSON,
    DevEventInboxMessageDtoToJSON,
    DevIngestionStatusDtoFromJSON,
    DevIngestionStatusDtoToJSON,
    DevOverviewDtoFromJSON,
    DevOverviewDtoToJSON,
    DevPriceRowDtoFromJSON,
    DevPriceRowDtoToJSON,
    DevPriceRowFilterFromJSON,
    DevPriceRowFilterToJSON,
    DevSettingDtoFromJSON,
    DevSettingDtoToJSON,
    DevTelemetryErrorDtoFromJSON,
    DevTelemetryErrorDtoToJSON,
    DevUserDtoFromJSON,
    DevUserDtoToJSON,
    FilteredListItemFromJSON,
    FilteredListItemToJSON,
    GetCalculationSettingsUploadTargetsResponseFromJSON,
    GetCalculationSettingsUploadTargetsResponseToJSON,
    GetCalculationTypesResponseFromJSON,
    GetCalculationTypesResponseToJSON,
    GetDetailedSimulationResponseFromJSON,
    GetDetailedSimulationResponseToJSON,
    GetKeyFiguresPreviousYearResponseFromJSON,
    GetKeyFiguresPreviousYearResponseToJSON,
    GetPresignedUrlRequestResponseFromJSON,
    GetPresignedUrlRequestResponseToJSON,
    GetPriceSettingsResponseFromJSON,
    GetPriceSettingsResponseToJSON,
    GetSimulationResponseFromJSON,
    GetSimulationResponseToJSON,
    GetTemplateResponseFromJSON,
    GetTemplateResponseToJSON,
    HasPermissionResponseFromJSON,
    HasPermissionResponseToJSON,
    LoadLelRrpPricesResponseFromJSON,
    LoadLelRrpPricesResponseToJSON,
    MigrateContactsRequestFromJSON,
    MigrateContactsRequestToJSON,
    NoveltyCalcRequestFromJSON,
    NoveltyCalcRequestToJSON,
    NoveltyCalcResponseFromJSON,
    NoveltyCalcResponseToJSON,
    PriceEventQueueStatusResponseFromJSON,
    PriceEventQueueStatusResponseToJSON,
    PriceForProductDtoFromJSON,
    PriceForProductDtoToJSON,
    PricePointDtoFromJSON,
    PricePointDtoToJSON,
    PriceUnitCategoryDtoFromJSON,
    PriceUnitCategoryDtoToJSON,
    PriceUnitDtoFromJSON,
    PriceUnitDtoToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    ProductDtoFromJSON,
    ProductDtoToJSON,
    PublishPricesRequestBodyFromJSON,
    PublishPricesRequestBodyToJSON,
    RecordSimulationMismatchesRequestBodyFromJSON,
    RecordSimulationMismatchesRequestBodyToJSON,
    RenameSimulationRequestBodyFromJSON,
    RenameSimulationRequestBodyToJSON,
    SaveCreatePriceRequestFromJSON,
    SaveCreatePriceRequestToJSON,
    SaveCreatePriceResponseFromJSON,
    SaveCreatePriceResponseToJSON,
    SaveCreatePriceSessionRequestFromJSON,
    SaveCreatePriceSessionRequestToJSON,
    SaveNoveltyCalcRequestBodyFromJSON,
    SaveNoveltyCalcRequestBodyToJSON,
    SavePriceRowsRequestBodyFromJSON,
    SavePriceRowsRequestBodyToJSON,
    SavePriceSettingsRequestBodyFromJSON,
    SavePriceSettingsRequestBodyToJSON,
    SimulationExcelFileNamesResponseFromJSON,
    SimulationExcelFileNamesResponseToJSON,
    SimulationFieldExtractionResultFromJSON,
    SimulationFieldExtractionResultToJSON,
    SimulationListEntryDtoFromJSON,
    SimulationListEntryDtoToJSON,
    SimulationOperationResultFromJSON,
    SimulationOperationResultToJSON,
    SimulationStatusFromJSON,
    SimulationStatusToJSON,
    StartSimulationRequestBodyFromJSON,
    StartSimulationRequestBodyToJSON,
    StartSimulationResponseFromJSON,
    StartSimulationResponseToJSON,
    SyncContactResponseFromJSON,
    SyncContactResponseToJSON,
    SyncTargetsToCalculationSettingsResultFromJSON,
    SyncTargetsToCalculationSettingsResultToJSON,
    TestResponseFromJSON,
    TestResponseToJSON,
    TriggerAutoCalcResponseFromJSON,
    TriggerAutoCalcResponseToJSON,
    UpdateDevSettingRequestFromJSON,
    UpdateDevSettingRequestToJSON,
    UpdateSimulationAssignmentRequestBodyFromJSON,
    UpdateSimulationAssignmentRequestBodyToJSON,
    UpdateWatchersRequestBodyFromJSON,
    UpdateWatchersRequestBodyToJSON,
    UploadFileProcessResultResponseFromJSON,
    UploadFileProcessResultResponseToJSON,
    UploadTypeFromJSON,
    UploadTypeToJSON,
    UserClaimsResponseFromJSON,
    UserClaimsResponseToJSON,
    UserPermissionsResponseFromJSON,
    UserPermissionsResponseToJSON,
    UserWithEmailDtoFromJSON,
    UserWithEmailDtoToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
    VersionEntryDtoFromJSON,
    VersionEntryDtoToJSON,
    WatcherDtoFromJSON,
    WatcherDtoToJSON,
} from '../models/index';

export interface AlternativeVatCheckRequest {
    date?: Date;
}

export interface ConvertVersionToSimulationRequest {
    simulationId: number;
    versionId: number;
    convertVersionRequestBody: ConvertVersionRequestBody;
}

export interface CopyPriceOperationRequest {
    copyPriceRequest: CopyPriceRequest;
}

export interface CopyPriceEligibleTargetsSourcePriceUnitIdRequest {
    sourcePriceUnitId: number;
    searchField?: string;
    limit?: number;
}

export interface CopyPricePreviewRequest {
    copyPriceRequest: CopyPriceRequest;
}

export interface CreateCalculationSettingsRequest {
    calculationSettingsRequestBody: CalculationSettingsRequestBody;
}

export interface CreateVersionRequest {
    simulationId: number;
}

export interface DeleteCreatePriceSessionRequest {
    mode: CreatePriceMode;
}

export interface DeleteNoveltyPricesOperationRequest {
    deleteNoveltyPricesRequest: DeleteNoveltyPricesRequest;
}

export interface DeleteVersionRequest {
    simulationId: number;
    versionId: number;
}

export interface DiscardNoveltyCalcResultsRequest {
    simulationId: number;
}

export interface DownloadSimulationExcelMismatchesRequest {
    prefix?: string;
}

export interface DownloadTemplateRequest {
    calculationSettingsTemplateDownloadRequest: CalculationSettingsTemplateDownloadRequest;
}

export interface ExtractSimulationExcelFieldsFromS3FileRequest {
    fileName: string;
}

export interface GetAssigneeCandidatesRequest {
    simulationId: number;
    targetStatus: SimulationStatus;
    query: string;
    limit?: number;
}

export interface GetCalculationSettingsForPriceUnitIdAndYearRequest {
    priceUnitId: number;
    year: number;
}

export interface GetCalculationSettingsPresignedPutUrlRequest {
    createPresignedUrlRequest: CreatePresignedUrlRequest;
}

export interface GetCreatePriceSessionRequest {
    mode: CreatePriceMode;
}

export interface GetDetailedSimulationRequest {
    simulationId: number;
}

export interface GetErrorReportRequest {
    fileLogId: string;
}

export interface GetKeyFiguresPreviousYearRequest {
    simulationId: number;
}

export interface GetPresignedPutUrlRequest {
    createPresignedUrlRequest: CreatePresignedUrlRequest;
}

export interface GetPriceSettingsRequest {
    simulationId: number;
}

export interface GetReviewerCandidatesRequest {
    simulationId: number;
    query: string;
    limit?: number;
}

export interface GetTemplateRequest {
    target?: string;
}

export interface GetVersionPriceSettingsRequest {
    simulationId: number;
    versionId: number;
}

export interface GetVersionsRequest {
    simulationId: number;
}

export interface GetWatcherCandidatesRequest {
    simulationId: number;
    query: string;
    limit?: number;
}

export interface GetWatchersRequest {
    simulationId: number;
}

export interface GroupsRequest {
    searchField: string;
    limit?: number;
    matrixOnly?: boolean;
    countryOnly?: boolean;
}

export interface ListSimulationExcelFilesRequest {
    prefix?: string;
}

export interface MigrateContactsOperationRequest {
    migrateContactsRequest?: MigrateContactsRequest;
}

export interface PreviewVersionAsSimulationRequest {
    simulationId: number;
    versionId: number;
}

export interface PriceUnitsRequest {
    searchField: string;
    limit?: number;
    matrixOnly?: boolean;
    countryOnly?: boolean;
}

export interface PriceUnitsSearchMultipleRequest {
    searchIds?: Array<number>;
}

export interface PricesForProductRequest {
    productId: number;
    priceUnitId: number;
}

export interface PricesPricePointsRequest {
    priceUnitId: number;
    planningYear: number;
    rrp: number;
}

export interface ProcessRequest {
    logId: string;
    type?: UploadType;
}

export interface ProcessCalculationSettingsUploadRequest {
    logId: string;
}

export interface ProductsRequest {
    searchField: string;
    limit?: number;
    matrixOnly?: boolean;
    countryOnly?: boolean;
}

export interface ProductsSearchMultipleRequest {
    searchIds?: Array<number>;
}

export interface PublishCreateAndGoToApproveRequest {
    saveCreatePriceSessionRequest: SaveCreatePriceSessionRequest;
}

export interface RecordSimulationExcelMismatchesRequest {
    recordSimulationMismatchesRequestBody: RecordSimulationMismatchesRequestBody;
}

export interface RenameSimulationRequest {
    simulationId: number;
    renameSimulationRequestBody: RenameSimulationRequestBody;
}

export interface RerunNoveltyCalcRequest {
    simulationId: number;
    noveltyCalcRequest: NoveltyCalcRequest;
}

export interface RestoreSimulationFromVersionRequest {
    simulationId: number;
    versionId: number;
}

export interface RunNoveltyCalcRequest {
    noveltyCalcRequest: NoveltyCalcRequest;
}

export interface SaveCreatePriceSessionOperationRequest {
    saveCreatePriceSessionRequest: SaveCreatePriceSessionRequest;
}

export interface SaveCreatePricesRequest {
    saveCreatePriceRequest: SaveCreatePriceRequest;
}

export interface SaveNoveltyCalcResultsRequest {
    simulationId: number;
    saveNoveltyCalcRequestBody: SaveNoveltyCalcRequestBody;
}

export interface SavePriceRowsRequest {
    simulationId: number;
    savePriceRowsRequestBody: SavePriceRowsRequestBody;
}

export interface SavePriceSettingsRequest {
    simulationId: number;
    savePriceSettingsRequestBody: SavePriceSettingsRequestBody;
}

export interface SearchDevDashboardAutoCalcLogsRequest {
    devAutoCalcLogFilter?: DevAutoCalcLogFilter;
}

export interface SearchDevDashboardBwPricesRequest {
    devPriceRowFilter?: DevPriceRowFilter;
}

export interface SearchDevDashboardEventInboxRequest {
    devEventInboxFilter?: DevEventInboxFilter;
}

export interface SearchDevDashboardPriceEventsRequest {
    devPriceRowFilter?: DevPriceRowFilter;
}

export interface SimulationDeleteRequest {
    requestBody: Array<number>;
}

export interface SimulationPublishPricesSimulationIdRequest {
    simulationId: number;
    publishPricesRequestBody?: PublishPricesRequestBody;
}

export interface SimulationSimulationIdRequest {
    simulationId: number;
}

export interface SimulationStartRequest {
    startSimulationRequestBody: StartSimulationRequestBody;
}

export interface StartCreatePriceExperienceRequest {
    createPriceExperienceRequest: CreatePriceExperienceRequest;
}

export interface ThemesRequest {
    searchField: string;
    limit?: number;
    matrixOnly?: boolean;
    countryOnly?: boolean;
}

export interface UpdateCalculationSettingsRequest {
    id: number;
    calculationSettingsRequestBody: CalculationSettingsRequestBody;
}

export interface UpdateDevDashboardSettingRequest {
    key: string;
    updateDevSettingRequest?: UpdateDevSettingRequest;
}

export interface UpdateSimulationAssignmentRequest {
    simulationId: number;
    updateSimulationAssignmentRequestBody: UpdateSimulationAssignmentRequestBody;
}

export interface UpdateWatchersRequest {
    simulationId: number;
    updateWatchersRequestBody: UpdateWatchersRequestBody;
}

export interface UserMeHasPermissionPermissionRequest {
    permission: string;
}

/**
 * 
 */
export class LPPSApi extends runtime.BaseAPI {

    /**
     */
    async alternativeVatCheckRaw(requestParameters: AlternativeVatCheckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters['date'] != null) {
            queryParameters['date'] = runtime.formatDateOnly(requestParameters['date'] as any);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/alternative-vat-check`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async alternativeVatCheck(requestParameters: AlternativeVatCheckRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.alternativeVatCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `ReadCalculationSettings`
     */
    async calculationSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CalculationSettingsDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/calculation-settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CalculationSettingsDtoFromJSON));
    }

    /**
     *   **Required Permission(s):** `ReadCalculationSettings`
     */
    async calculationSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CalculationSettingsDto>> {
        const response = await this.calculationSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `WriteSimulations`
     */
    async convertVersionToSimulationRaw(requestParameters: ConvertVersionToSimulationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling convertVersionToSimulation().'
            );
        }

        if (requestParameters['versionId'] == null) {
            throw new runtime.RequiredError(
                'versionId',
                'Required parameter "versionId" was null or undefined when calling convertVersionToSimulation().'
            );
        }

        if (requestParameters['convertVersionRequestBody'] == null) {
            throw new runtime.RequiredError(
                'convertVersionRequestBody',
                'Required parameter "convertVersionRequestBody" was null or undefined when calling convertVersionToSimulation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/{simulationId}/versions/{versionId}/simulation`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters['simulationId']))).replace(`{${"versionId"}}`, encodeURIComponent(String(requestParameters['versionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConvertVersionRequestBodyToJSON(requestParameters['convertVersionRequestBody']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     *   **Required Permission(s):** `WriteSimulations`
     */
    async convertVersionToSimulation(requestParameters: ConvertVersionToSimulationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.convertVersionToSimulationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Copies prices from a source price unit to one or more target price units based on the specified copy rule  **Required Permission(s):** `CopyPrice`
     * Copy prices between price units
     */
    async copyPriceRaw(requestParameters: CopyPriceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CopyPriceResponse>> {
        if (requestParameters['copyPriceRequest'] == null) {
            throw new runtime.RequiredError(
                'copyPriceRequest',
                'Required parameter "copyPriceRequest" was null or undefined when calling copyPrice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/copy-price`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CopyPriceRequestToJSON(requestParameters['copyPriceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CopyPriceResponseFromJSON(jsonValue));
    }

    /**
     * Copies prices from a source price unit to one or more target price units based on the specified copy rule  **Required Permission(s):** `CopyPrice`
     * Copy prices between price units
     */
    async copyPrice(requestParameters: CopyPriceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CopyPriceResponse> {
        const response = await this.copyPriceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns price units that can be used as targets when copying from the specified source price unit  **Required Permission(s):** `CopyPrice`
     * Get eligible copy targets
     */
    async copyPriceEligibleTargetsSourcePriceUnitIdRaw(requestParameters: CopyPriceEligibleTargetsSourcePriceUnitIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PriceUnitDto>>> {
        if (requestParameters['sourcePriceUnitId'] == null) {
            throw new runtime.RequiredError(
                'sourcePriceUnitId',
                'Required parameter "sourcePriceUnitId" was null or undefined when calling copyPriceEligibleTargetsSourcePriceUnitId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['searchField'] != null) {
            queryParameters['SearchField'] = requestParameters['searchField'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['Limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/copy-price/eligible-targets/{sourcePriceUnitId}`.replace(`{${"sourcePriceUnitId"}}`, encodeURIComponent(String(requestParameters['sourcePriceUnitId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PriceUnitDtoFromJSON));
    }

    /**
     * Returns price units that can be used as targets when copying from the specified source price unit  **Required Permission(s):** `CopyPrice`
     * Get eligible copy targets
     */
    async copyPriceEligibleTargetsSourcePriceUnitId(requestParameters: CopyPriceEligibleTargetsSourcePriceUnitIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PriceUnitDto>> {
        const response = await this.copyPriceEligibleTargetsSourcePriceUnitIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a detailed preview of what would be copied without making any changes. Use this to verify the copy operation before executing it.  **Required Permission(s):** `CopyPrice`
     * Preview copy prices operation
     */
    async copyPricePreviewRaw(requestParameters: CopyPricePreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CopyPricePreviewResponse>> {
        if (requestParameters['copyPriceRequest'] == null) {
            throw new runtime.RequiredError(
                'copyPriceRequest',
                'Required parameter "copyPriceRequest" was null or undefined when calling copyPricePreview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/copy-price/preview`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CopyPriceRequestToJSON(requestParameters['copyPriceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CopyPricePreviewResponseFromJSON(jsonValue));
    }

    /**
     * Returns a detailed preview of what would be copied without making any changes. Use this to verify the copy operation before executing it.  **Required Permission(s):** `CopyPrice`
     * Preview copy prices operation
     */
    async copyPricePreview(requestParameters: CopyPricePreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CopyPricePreviewResponse> {
        const response = await this.copyPricePreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `WriteCalculationSettings`
     */
    async createCalculationSettingsRaw(requestParameters: CreateCalculationSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CalculationSettingsDto>> {
        if (requestParameters['calculationSettingsRequestBody'] == null) {
            throw new runtime.RequiredError(
                'calculationSettingsRequestBody',
                'Required parameter "calculationSettingsRequestBody" was null or undefined when calling createCalculationSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/calculation-settings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CalculationSettingsRequestBodyToJSON(requestParameters['calculationSettingsRequestBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CalculationSettingsDtoFromJSON(jsonValue));
    }

    /**
     *   **Required Permission(s):** `WriteCalculationSettings`
     */
    async createCalculationSettings(requestParameters: CreateCalculationSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CalculationSettingsDto> {
        const response = await this.createCalculationSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `WriteSimulations`
     */
    async createVersionRaw(requestParameters: CreateVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling createVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/{simulationId}/versions`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters['simulationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     *   **Required Permission(s):** `WriteSimulations`
     */
    async createVersion(requestParameters: CreateVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createVersionRaw(requestParameters, initOverrides);
    }

    /**
     *   **Required Permission(s):** `CreatePrice`
     */
    async deleteCreatePriceSessionRaw(requestParameters: DeleteCreatePriceSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['mode'] == null) {
            throw new runtime.RequiredError(
                'mode',
                'Required parameter "mode" was null or undefined when calling deleteCreatePriceSession().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['mode'] != null) {
            queryParameters['mode'] = requestParameters['mode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/create-price-experience/session`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     *   **Required Permission(s):** `CreatePrice`
     */
    async deleteCreatePriceSession(requestParameters: DeleteCreatePriceSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCreatePriceSessionRaw(requestParameters, initOverrides);
    }

    /**
     * Permanently deletes novelty prices for a single Country price unit, regardless of price status (preliminary or approved). Only product_plan_price rows belonging to product plans with a half-year launch status (FirstHalf/SecondHalf) are removed. Always scoped to the next planning year (current year + 1); the year is not user-selectable.  **Required Permission(s):** `DeleteNoveltyPrices`
     * Delete novelty prices
     */
    async deleteNoveltyPricesRaw(requestParameters: DeleteNoveltyPricesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteNoveltyPricesResponse>> {
        if (requestParameters['deleteNoveltyPricesRequest'] == null) {
            throw new runtime.RequiredError(
                'deleteNoveltyPricesRequest',
                'Required parameter "deleteNoveltyPricesRequest" was null or undefined when calling deleteNoveltyPrices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/novelty-calc/novelty-prices`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteNoveltyPricesRequestToJSON(requestParameters['deleteNoveltyPricesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteNoveltyPricesResponseFromJSON(jsonValue));
    }

    /**
     * Permanently deletes novelty prices for a single Country price unit, regardless of price status (preliminary or approved). Only product_plan_price rows belonging to product plans with a half-year launch status (FirstHalf/SecondHalf) are removed. Always scoped to the next planning year (current year + 1); the year is not user-selectable.  **Required Permission(s):** `DeleteNoveltyPrices`
     * Delete novelty prices
     */
    async deleteNoveltyPrices(requestParameters: DeleteNoveltyPricesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteNoveltyPricesResponse> {
        const response = await this.deleteNoveltyPricesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `DeleteSimulations`
     */
    async deleteVersionRaw(requestParameters: DeleteVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling deleteVersion().'
            );
        }

        if (requestParameters['versionId'] == null) {
            throw new runtime.RequiredError(
                'versionId',
                'Required parameter "versionId" was null or undefined when calling deleteVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/{simulationId}/versions/{versionId}`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters['simulationId']))).replace(`{${"versionId"}}`, encodeURIComponent(String(requestParameters['versionId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     *   **Required Permission(s):** `DeleteSimulations`
     */
    async deleteVersion(requestParameters: DeleteVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteVersionRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes the PreDraft simulation created by a NoveltyCalc run.  **Required Permission(s):** `NoveltyCalculation`
     * Discard NoveltyCalc results
     */
    async discardNoveltyCalcResultsRaw(requestParameters: DiscardNoveltyCalcResultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling discardNoveltyCalcResults().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/novelty-calc/{simulationId}`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters['simulationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes the PreDraft simulation created by a NoveltyCalc run.  **Required Permission(s):** `NoveltyCalculation`
     * Discard NoveltyCalc results
     */
    async discardNoveltyCalcResults(requestParameters: DiscardNoveltyCalcResultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.discardNoveltyCalcResultsRaw(requestParameters, initOverrides);
    }

    /**
     *   **Required Permission(s):** `CompareSimulations`
     */
    async downloadSimulationExcelMismatchesRaw(requestParameters: DownloadSimulationExcelMismatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['prefix'] != null) {
            queryParameters['prefix'] = requestParameters['prefix'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/comparison/mismatches`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     *   **Required Permission(s):** `CompareSimulations`
     */
    async downloadSimulationExcelMismatches(requestParameters: DownloadSimulationExcelMismatchesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.downloadSimulationExcelMismatchesRaw(requestParameters, initOverrides);
    }

    /**
     *   **Required Permission(s):** `ReadCalculationSettings`
     */
    async downloadTemplateRaw(requestParameters: DownloadTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTemplateResponse>> {
        if (requestParameters['calculationSettingsTemplateDownloadRequest'] == null) {
            throw new runtime.RequiredError(
                'calculationSettingsTemplateDownloadRequest',
                'Required parameter "calculationSettingsTemplateDownloadRequest" was null or undefined when calling downloadTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/template-download`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CalculationSettingsTemplateDownloadRequestToJSON(requestParameters['calculationSettingsTemplateDownloadRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTemplateResponseFromJSON(jsonValue));
    }

    /**
     *   **Required Permission(s):** `ReadCalculationSettings`
     */
    async downloadTemplate(requestParameters: DownloadTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTemplateResponse> {
        const response = await this.downloadTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `CompareSimulations`
     */
    async extractSimulationExcelFieldsFromS3FileRaw(requestParameters: ExtractSimulationExcelFieldsFromS3FileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SimulationFieldExtractionResult>> {
        if (requestParameters['fileName'] == null) {
            throw new runtime.RequiredError(
                'fileName',
                'Required parameter "fileName" was null or undefined when calling extractSimulationExcelFieldsFromS3File().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['fileName'] != null) {
            queryParameters['fileName'] = requestParameters['fileName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/comparison/files/fields`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SimulationFieldExtractionResultFromJSON(jsonValue));
    }

    /**
     *   **Required Permission(s):** `CompareSimulations`
     */
    async extractSimulationExcelFieldsFromS3File(requestParameters: ExtractSimulationExcelFieldsFromS3FileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SimulationFieldExtractionResult> {
        const response = await this.extractSimulationExcelFieldsFromS3FileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `ReadSimulations`
     */
    async getAssigneeCandidatesRaw(requestParameters: GetAssigneeCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssigneeCandidateDto>>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling getAssigneeCandidates().'
            );
        }

        if (requestParameters['targetStatus'] == null) {
            throw new runtime.RequiredError(
                'targetStatus',
                'Required parameter "targetStatus" was null or undefined when calling getAssigneeCandidates().'
            );
        }

        if (requestParameters['query'] == null) {
            throw new runtime.RequiredError(
                'query',
                'Required parameter "query" was null or undefined when calling getAssigneeCandidates().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['targetStatus'] != null) {
            queryParameters['targetStatus'] = requestParameters['targetStatus'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/{simulationId}/assignee-candidates`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters['simulationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssigneeCandidateDtoFromJSON));
    }

    /**
     *   **Required Permission(s):** `ReadSimulations`
     */
    async getAssigneeCandidates(requestParameters: GetAssigneeCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssigneeCandidateDto>> {
        const response = await this.getAssigneeCandidatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `ReadCalculationSettings`
     */
    async getCalculationSettingsForPriceUnitIdAndYearRaw(requestParameters: GetCalculationSettingsForPriceUnitIdAndYearRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CalculationSettingsDto>> {
        if (requestParameters['priceUnitId'] == null) {
            throw new runtime.RequiredError(
                'priceUnitId',
                'Required parameter "priceUnitId" was null or undefined when calling getCalculationSettingsForPriceUnitIdAndYear().'
            );
        }

        if (requestParameters['year'] == null) {
            throw new runtime.RequiredError(
                'year',
                'Required parameter "year" was null or undefined when calling getCalculationSettingsForPriceUnitIdAndYear().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/calculation-settings/{priceUnitId}/year/{year}`.replace(`{${"priceUnitId"}}`, encodeURIComponent(String(requestParameters['priceUnitId']))).replace(`{${"year"}}`, encodeURIComponent(String(requestParameters['year']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CalculationSettingsDtoFromJSON(jsonValue));
    }

    /**
     *   **Required Permission(s):** `ReadCalculationSettings`
     */
    async getCalculationSettingsForPriceUnitIdAndYear(requestParameters: GetCalculationSettingsForPriceUnitIdAndYearRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CalculationSettingsDto> {
        const response = await this.getCalculationSettingsForPriceUnitIdAndYearRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `WriteCalculationSettings`
     */
    async getCalculationSettingsPresignedPutUrlRaw(requestParameters: GetCalculationSettingsPresignedPutUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPresignedUrlRequestResponse>> {
        if (requestParameters['createPresignedUrlRequest'] == null) {
            throw new runtime.RequiredError(
                'createPresignedUrlRequest',
                'Required parameter "createPresignedUrlRequest" was null or undefined when calling getCalculationSettingsPresignedPutUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/calculation-settings/presign`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePresignedUrlRequestToJSON(requestParameters['createPresignedUrlRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPresignedUrlRequestResponseFromJSON(jsonValue));
    }

    /**
     *   **Required Permission(s):** `WriteCalculationSettings`
     */
    async getCalculationSettingsPresignedPutUrl(requestParameters: GetCalculationSettingsPresignedPutUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPresignedUrlRequestResponse> {
        const response = await this.getCalculationSettingsPresignedPutUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `ReadCalculationSettings`
     */
    async getCalculationSettingsUploadTargetsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCalculationSettingsUploadTargetsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/calculation-settings/upload-targets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCalculationSettingsUploadTargetsResponseFromJSON(jsonValue));
    }

    /**
     *   **Required Permission(s):** `ReadCalculationSettings`
     */
    async getCalculationSettingsUploadTargets(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCalculationSettingsUploadTargetsResponse> {
        const response = await this.getCalculationSettingsUploadTargetsRaw(initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `ReadCalculationSettings`
     */
    async getCalculationTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCalculationTypesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/calculation-settings/types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCalculationTypesResponseFromJSON(jsonValue));
    }

    /**
     *   **Required Permission(s):** `ReadCalculationSettings`
     */
    async getCalculationTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCalculationTypesResponse> {
        const response = await this.getCalculationTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `CreatePrice`
     */
    async getCreatePriceSessionRaw(requestParameters: GetCreatePriceSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePriceSessionResponse>> {
        if (requestParameters['mode'] == null) {
            throw new runtime.RequiredError(
                'mode',
                'Required parameter "mode" was null or undefined when calling getCreatePriceSession().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['mode'] != null) {
            queryParameters['mode'] = requestParameters['mode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/create-price-experience/session`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePriceSessionResponseFromJSON(jsonValue));
    }

    /**
     *   **Required Permission(s):** `CreatePrice`
     */
    async getCreatePriceSession(requestParameters: GetCreatePriceSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePriceSessionResponse> {
        const response = await this.getCreatePriceSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `ReadSimulations`
     */
    async getDetailedSimulationRaw(requestParameters: GetDetailedSimulationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDetailedSimulationResponse>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling getDetailedSimulation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/{simulationId}/detailed`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters['simulationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDetailedSimulationResponseFromJSON(jsonValue));
    }

    /**
     *   **Required Permission(s):** `ReadSimulations`
     */
    async getDetailedSimulation(requestParameters: GetDetailedSimulationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDetailedSimulationResponse> {
        const response = await this.getDetailedSimulationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `AccessTestEndpoints`
     */
    async getDevDashboardAutoCalcRunsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DevAutoCalcRunDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dev/dashboard/autocalc-logs/runs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DevAutoCalcRunDtoFromJSON));
    }

    /**
     *   **Required Permission(s):** `AccessTestEndpoints`
     */
    async getDevDashboardAutoCalcRuns(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DevAutoCalcRunDto>> {
        const response = await this.getDevDashboardAutoCalcRunsRaw(initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `AccessTestEndpoints`
     */
    async getDevDashboardIngestionStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevIngestionStatusDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dev/dashboard/ingestion-status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevIngestionStatusDtoFromJSON(jsonValue));
    }

    /**
     *   **Required Permission(s):** `AccessTestEndpoints`
     */
    async getDevDashboardIngestionStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevIngestionStatusDto> {
        const response = await this.getDevDashboardIngestionStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `AccessTestEndpoints`
     */
    async getDevDashboardOverviewRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevOverviewDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dev/dashboard/overview`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevOverviewDtoFromJSON(jsonValue));
    }

    /**
     *   **Required Permission(s):** `AccessTestEndpoints`
     */
    async getDevDashboardOverview(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevOverviewDto> {
        const response = await this.getDevDashboardOverviewRaw(initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `AccessTestEndpoints`
     */
    async getDevDashboardSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DevSettingDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dev/dashboard/settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DevSettingDtoFromJSON));
    }

    /**
     *   **Required Permission(s):** `AccessTestEndpoints`
     */
    async getDevDashboardSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DevSettingDto>> {
        const response = await this.getDevDashboardSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `AccessTestEndpoints`
     */
    async getDevDashboardTelemetryErrorsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DevTelemetryErrorDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dev/dashboard/telemetry-errors`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DevTelemetryErrorDtoFromJSON));
    }

    /**
     *   **Required Permission(s):** `AccessTestEndpoints`
     */
    async getDevDashboardTelemetryErrors(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DevTelemetryErrorDto>> {
        const response = await this.getDevDashboardTelemetryErrorsRaw(initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `AccessTestEndpoints`
     */
    async getDevDashboardUsersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DevUserDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dev/dashboard/users`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DevUserDtoFromJSON));
    }

    /**
     *   **Required Permission(s):** `AccessTestEndpoints`
     */
    async getDevDashboardUsers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DevUserDto>> {
        const response = await this.getDevDashboardUsersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getErrorReportRaw(requestParameters: GetErrorReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPresignedUrlRequestResponse>> {
        if (requestParameters['fileLogId'] == null) {
            throw new runtime.RequiredError(
                'fileLogId',
                'Required parameter "fileLogId" was null or undefined when calling getErrorReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/error-report/{fileLogId}`.replace(`{${"fileLogId"}}`, encodeURIComponent(String(requestParameters['fileLogId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPresignedUrlRequestResponseFromJSON(jsonValue));
    }

    /**
     */
    async getErrorReport(requestParameters: GetErrorReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPresignedUrlRequestResponse> {
        const response = await this.getErrorReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `ReadSimulations`
     */
    async getKeyFiguresPreviousYearRaw(requestParameters: GetKeyFiguresPreviousYearRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetKeyFiguresPreviousYearResponse>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling getKeyFiguresPreviousYear().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/{simulationId}/key-figures/previous-year`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters['simulationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetKeyFiguresPreviousYearResponseFromJSON(jsonValue));
    }

    /**
     *   **Required Permission(s):** `ReadSimulations`
     */
    async getKeyFiguresPreviousYear(requestParameters: GetKeyFiguresPreviousYearRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetKeyFiguresPreviousYearResponse> {
        const response = await this.getKeyFiguresPreviousYearRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPresignedPutUrlRaw(requestParameters: GetPresignedPutUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPresignedUrlRequestResponse>> {
        if (requestParameters['createPresignedUrlRequest'] == null) {
            throw new runtime.RequiredError(
                'createPresignedUrlRequest',
                'Required parameter "createPresignedUrlRequest" was null or undefined when calling getPresignedPutUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/presign`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePresignedUrlRequestToJSON(requestParameters['createPresignedUrlRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPresignedUrlRequestResponseFromJSON(jsonValue));
    }

    /**
     */
    async getPresignedPutUrl(requestParameters: GetPresignedPutUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPresignedUrlRequestResponse> {
        const response = await this.getPresignedPutUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPriceEventQueueStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PriceEventQueueStatusResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/price-events/queue-status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PriceEventQueueStatusResponseFromJSON(jsonValue));
    }

    /**
     */
    async getPriceEventQueueStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PriceEventQueueStatusResponse> {
        const response = await this.getPriceEventQueueStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `ReadSimulations`
     */
    async getPriceSettingsRaw(requestParameters: GetPriceSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPriceSettingsResponse>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling getPriceSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/{simulationId}/price-settings`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters['simulationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPriceSettingsResponseFromJSON(jsonValue));
    }

    /**
     *   **Required Permission(s):** `ReadSimulations`
     */
    async getPriceSettings(requestParameters: GetPriceSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPriceSettingsResponse> {
        const response = await this.getPriceSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `ReadSimulations`
     */
    async getReviewerCandidatesRaw(requestParameters: GetReviewerCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserWithEmailDto>>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling getReviewerCandidates().'
            );
        }

        if (requestParameters['query'] == null) {
            throw new runtime.RequiredError(
                'query',
                'Required parameter "query" was null or undefined when calling getReviewerCandidates().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/{simulationId}/reviewer-candidates`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters['simulationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserWithEmailDtoFromJSON));
    }

    /**
     *   **Required Permission(s):** `ReadSimulations`
     */
    async getReviewerCandidates(requestParameters: GetReviewerCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserWithEmailDto>> {
        const response = await this.getReviewerCandidatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTemplateRaw(requestParameters: GetTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTemplateResponse>> {
        const queryParameters: any = {};

        if (requestParameters['target'] != null) {
            queryParameters['target'] = requestParameters['target'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/template`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTemplateResponseFromJSON(jsonValue));
    }

    /**
     */
    async getTemplate(requestParameters: GetTemplateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTemplateResponse> {
        const response = await this.getTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `ReadSimulations`
     */
    async getVersionPriceSettingsRaw(requestParameters: GetVersionPriceSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPriceSettingsResponse>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling getVersionPriceSettings().'
            );
        }

        if (requestParameters['versionId'] == null) {
            throw new runtime.RequiredError(
                'versionId',
                'Required parameter "versionId" was null or undefined when calling getVersionPriceSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/{simulationId}/versions/{versionId}/price-settings`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters['simulationId']))).replace(`{${"versionId"}}`, encodeURIComponent(String(requestParameters['versionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPriceSettingsResponseFromJSON(jsonValue));
    }

    /**
     *   **Required Permission(s):** `ReadSimulations`
     */
    async getVersionPriceSettings(requestParameters: GetVersionPriceSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPriceSettingsResponse> {
        const response = await this.getVersionPriceSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `ReadSimulations`
     */
    async getVersionsRaw(requestParameters: GetVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VersionEntryDto>>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling getVersions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/{simulationId}/versions`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters['simulationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VersionEntryDtoFromJSON));
    }

    /**
     *   **Required Permission(s):** `ReadSimulations`
     */
    async getVersions(requestParameters: GetVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VersionEntryDto>> {
        const response = await this.getVersionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `WriteSimulations`
     */
    async getWatcherCandidatesRaw(requestParameters: GetWatcherCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserWithEmailDto>>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling getWatcherCandidates().'
            );
        }

        if (requestParameters['query'] == null) {
            throw new runtime.RequiredError(
                'query',
                'Required parameter "query" was null or undefined when calling getWatcherCandidates().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/{simulationId}/watcher-candidates`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters['simulationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserWithEmailDtoFromJSON));
    }

    /**
     *   **Required Permission(s):** `WriteSimulations`
     */
    async getWatcherCandidates(requestParameters: GetWatcherCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserWithEmailDto>> {
        const response = await this.getWatcherCandidatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `ReadSimulations`
     */
    async getWatchersRaw(requestParameters: GetWatchersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WatcherDto>>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling getWatchers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/{simulationId}/watchers`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters['simulationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WatcherDtoFromJSON));
    }

    /**
     *   **Required Permission(s):** `ReadSimulations`
     */
    async getWatchers(requestParameters: GetWatchersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WatcherDto>> {
        const response = await this.getWatchersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async groupsRaw(requestParameters: GroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FilteredListItem>>> {
        if (requestParameters['searchField'] == null) {
            throw new runtime.RequiredError(
                'searchField',
                'Required parameter "searchField" was null or undefined when calling groups().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['searchField'] != null) {
            queryParameters['SearchField'] = requestParameters['searchField'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['Limit'] = requestParameters['limit'];
        }

        if (requestParameters['matrixOnly'] != null) {
            queryParameters['MatrixOnly'] = requestParameters['matrixOnly'];
        }

        if (requestParameters['countryOnly'] != null) {
            queryParameters['CountryOnly'] = requestParameters['countryOnly'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/groups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FilteredListItemFromJSON));
    }

    /**
     */
    async groups(requestParameters: GroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FilteredListItem>> {
        const response = await this.groupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `CompareSimulations`
     */
    async listSimulationExcelFilesRaw(requestParameters: ListSimulationExcelFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SimulationExcelFileNamesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['prefix'] != null) {
            queryParameters['prefix'] = requestParameters['prefix'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/comparison/files`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SimulationExcelFileNamesResponseFromJSON(jsonValue));
    }

    /**
     *   **Required Permission(s):** `CompareSimulations`
     */
    async listSimulationExcelFiles(requestParameters: ListSimulationExcelFilesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SimulationExcelFileNamesResponse> {
        const response = await this.listSimulationExcelFilesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `ManageLelPrices`
     */
    async loadLelRrpPricesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoadLelRrpPricesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/prices/load-lel-rrp-prices`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoadLelRrpPricesResponseFromJSON(jsonValue));
    }

    /**
     *   **Required Permission(s):** `ManageLelPrices`
     */
    async loadLelRrpPrices(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoadLelRrpPricesResponse> {
        const response = await this.loadLelRrpPricesRaw(initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `AccessTestEndpoints`
     */
    async migrateContactsRaw(requestParameters: MigrateContactsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/contacts/migrate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MigrateContactsRequestToJSON(requestParameters['migrateContactsRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     *   **Required Permission(s):** `AccessTestEndpoints`
     */
    async migrateContacts(requestParameters: MigrateContactsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.migrateContactsRaw(requestParameters, initOverrides);
    }

    /**
     *   **Required Permission(s):** `ReadSimulations`
     */
    async previewVersionAsSimulationRaw(requestParameters: PreviewVersionAsSimulationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDetailedSimulationResponse>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling previewVersionAsSimulation().'
            );
        }

        if (requestParameters['versionId'] == null) {
            throw new runtime.RequiredError(
                'versionId',
                'Required parameter "versionId" was null or undefined when calling previewVersionAsSimulation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/{simulationId}/versions/{versionId}/preview`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters['simulationId']))).replace(`{${"versionId"}}`, encodeURIComponent(String(requestParameters['versionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDetailedSimulationResponseFromJSON(jsonValue));
    }

    /**
     *   **Required Permission(s):** `ReadSimulations`
     */
    async previewVersionAsSimulation(requestParameters: PreviewVersionAsSimulationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDetailedSimulationResponse> {
        const response = await this.previewVersionAsSimulationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async priceUnitCategoriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PriceUnitCategoryDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/price-unit-categories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PriceUnitCategoryDtoFromJSON));
    }

    /**
     */
    async priceUnitCategories(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PriceUnitCategoryDto>> {
        const response = await this.priceUnitCategoriesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async priceUnitsRaw(requestParameters: PriceUnitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PriceUnitDto>>> {
        if (requestParameters['searchField'] == null) {
            throw new runtime.RequiredError(
                'searchField',
                'Required parameter "searchField" was null or undefined when calling priceUnits().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['searchField'] != null) {
            queryParameters['SearchField'] = requestParameters['searchField'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['Limit'] = requestParameters['limit'];
        }

        if (requestParameters['matrixOnly'] != null) {
            queryParameters['MatrixOnly'] = requestParameters['matrixOnly'];
        }

        if (requestParameters['countryOnly'] != null) {
            queryParameters['CountryOnly'] = requestParameters['countryOnly'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/price-units`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PriceUnitDtoFromJSON));
    }

    /**
     */
    async priceUnits(requestParameters: PriceUnitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PriceUnitDto>> {
        const response = await this.priceUnitsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async priceUnitsSearchMultipleRaw(requestParameters: PriceUnitsSearchMultipleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: PriceUnitDto; }>> {
        const queryParameters: any = {};

        if (requestParameters['searchIds'] != null) {
            queryParameters['searchIds'] = requestParameters['searchIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/price-units/search-multiple`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => runtime.mapValues(jsonValue, PriceUnitDtoFromJSON));
    }

    /**
     */
    async priceUnitsSearchMultiple(requestParameters: PriceUnitsSearchMultipleRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: PriceUnitDto; }> {
        const response = await this.priceUnitsSearchMultipleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `ReadPrices`
     */
    async pricesForProductRaw(requestParameters: PricesForProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PriceForProductDto>>> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling pricesForProduct().'
            );
        }

        if (requestParameters['priceUnitId'] == null) {
            throw new runtime.RequiredError(
                'priceUnitId',
                'Required parameter "priceUnitId" was null or undefined when calling pricesForProduct().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['productId'] != null) {
            queryParameters['productId'] = requestParameters['productId'];
        }

        if (requestParameters['priceUnitId'] != null) {
            queryParameters['priceUnitId'] = requestParameters['priceUnitId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/prices/for-product`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PriceForProductDtoFromJSON));
    }

    /**
     *   **Required Permission(s):** `ReadPrices`
     */
    async pricesForProduct(requestParameters: PricesForProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PriceForProductDto> | null | undefined > {
        const response = await this.pricesForProductRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     */
    async pricesPricePointsRaw(requestParameters: PricesPricePointsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PricePointDto>> {
        if (requestParameters['priceUnitId'] == null) {
            throw new runtime.RequiredError(
                'priceUnitId',
                'Required parameter "priceUnitId" was null or undefined when calling pricesPricePoints().'
            );
        }

        if (requestParameters['planningYear'] == null) {
            throw new runtime.RequiredError(
                'planningYear',
                'Required parameter "planningYear" was null or undefined when calling pricesPricePoints().'
            );
        }

        if (requestParameters['rrp'] == null) {
            throw new runtime.RequiredError(
                'rrp',
                'Required parameter "rrp" was null or undefined when calling pricesPricePoints().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['priceUnitId'] != null) {
            queryParameters['priceUnitId'] = requestParameters['priceUnitId'];
        }

        if (requestParameters['planningYear'] != null) {
            queryParameters['planningYear'] = requestParameters['planningYear'];
        }

        if (requestParameters['rrp'] != null) {
            queryParameters['rrp'] = requestParameters['rrp'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/prices/price-points`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PricePointDtoFromJSON(jsonValue));
    }

    /**
     */
    async pricesPricePoints(requestParameters: PricesPricePointsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PricePointDto | null | undefined > {
        const response = await this.pricesPricePointsRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     */
    async processRaw(requestParameters: ProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadFileProcessResultResponse>> {
        if (requestParameters['logId'] == null) {
            throw new runtime.RequiredError(
                'logId',
                'Required parameter "logId" was null or undefined when calling process().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/{logId}/process`.replace(`{${"logId"}}`, encodeURIComponent(String(requestParameters['logId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadFileProcessResultResponseFromJSON(jsonValue));
    }

    /**
     */
    async process(requestParameters: ProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadFileProcessResultResponse> {
        const response = await this.processRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `WriteCalculationSettings`
     */
    async processCalculationSettingsUploadRaw(requestParameters: ProcessCalculationSettingsUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CalculationSettingsFileProcessResultResponse>> {
        if (requestParameters['logId'] == null) {
            throw new runtime.RequiredError(
                'logId',
                'Required parameter "logId" was null or undefined when calling processCalculationSettingsUpload().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/calculation-settings/{logId}/process`.replace(`{${"logId"}}`, encodeURIComponent(String(requestParameters['logId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CalculationSettingsFileProcessResultResponseFromJSON(jsonValue));
    }

    /**
     *   **Required Permission(s):** `WriteCalculationSettings`
     */
    async processCalculationSettingsUpload(requestParameters: ProcessCalculationSettingsUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CalculationSettingsFileProcessResultResponse> {
        const response = await this.processCalculationSettingsUploadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async productsRaw(requestParameters: ProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProductDto>>> {
        if (requestParameters['searchField'] == null) {
            throw new runtime.RequiredError(
                'searchField',
                'Required parameter "searchField" was null or undefined when calling products().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['searchField'] != null) {
            queryParameters['SearchField'] = requestParameters['searchField'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['Limit'] = requestParameters['limit'];
        }

        if (requestParameters['matrixOnly'] != null) {
            queryParameters['MatrixOnly'] = requestParameters['matrixOnly'];
        }

        if (requestParameters['countryOnly'] != null) {
            queryParameters['CountryOnly'] = requestParameters['countryOnly'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/products`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProductDtoFromJSON));
    }

    /**
     */
    async products(requestParameters: ProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProductDto>> {
        const response = await this.productsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async productsSearchMultipleRaw(requestParameters: ProductsSearchMultipleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: ProductDto; }>> {
        const queryParameters: any = {};

        if (requestParameters['searchIds'] != null) {
            queryParameters['searchIds'] = requestParameters['searchIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/products/search-multiple`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => runtime.mapValues(jsonValue, ProductDtoFromJSON));
    }

    /**
     */
    async productsSearchMultiple(requestParameters: ProductsSearchMultipleRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: ProductDto; }> {
        const response = await this.productsSearchMultipleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `CreatePrice`
     */
    async publishCreateAndGoToApproveRaw(requestParameters: PublishCreateAndGoToApproveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['saveCreatePriceSessionRequest'] == null) {
            throw new runtime.RequiredError(
                'saveCreatePriceSessionRequest',
                'Required parameter "saveCreatePriceSessionRequest" was null or undefined when calling publishCreateAndGoToApprove().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/create-price-experience/session/publish-and-go-to-approve`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SaveCreatePriceSessionRequestToJSON(requestParameters['saveCreatePriceSessionRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     *   **Required Permission(s):** `CreatePrice`
     */
    async publishCreateAndGoToApprove(requestParameters: PublishCreateAndGoToApproveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.publishCreateAndGoToApproveRaw(requestParameters, initOverrides);
    }

    /**
     *   **Required Permission(s):** `CompareSimulations`
     */
    async recordSimulationExcelMismatchesRaw(requestParameters: RecordSimulationExcelMismatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['recordSimulationMismatchesRequestBody'] == null) {
            throw new runtime.RequiredError(
                'recordSimulationMismatchesRequestBody',
                'Required parameter "recordSimulationMismatchesRequestBody" was null or undefined when calling recordSimulationExcelMismatches().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/comparison/mismatches`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RecordSimulationMismatchesRequestBodyToJSON(requestParameters['recordSimulationMismatchesRequestBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     *   **Required Permission(s):** `CompareSimulations`
     */
    async recordSimulationExcelMismatches(requestParameters: RecordSimulationExcelMismatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.recordSimulationExcelMismatchesRaw(requestParameters, initOverrides);
    }

    /**
     *   **Required Permission(s):** `WriteSimulations`
     */
    async renameSimulationRaw(requestParameters: RenameSimulationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling renameSimulation().'
            );
        }

        if (requestParameters['renameSimulationRequestBody'] == null) {
            throw new runtime.RequiredError(
                'renameSimulationRequestBody',
                'Required parameter "renameSimulationRequestBody" was null or undefined when calling renameSimulation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/{simulationId}`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters['simulationId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: RenameSimulationRequestBodyToJSON(requestParameters['renameSimulationRequestBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     *   **Required Permission(s):** `WriteSimulations`
     */
    async renameSimulation(requestParameters: RenameSimulationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.renameSimulationRaw(requestParameters, initOverrides);
    }

    /**
     * Runs NoveltyCalc again with the given parameters and, only on success, discards the existing PreDraft simulation in favor of the new one. If the new run fails (grouped error entries returned, same shape as Run), the existing PreDraft simulation is left untouched.  **Required Permission(s):** `NoveltyCalculation`
     * Rerun NoveltyCalc
     */
    async rerunNoveltyCalcRaw(requestParameters: RerunNoveltyCalcRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NoveltyCalcResponse>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling rerunNoveltyCalc().'
            );
        }

        if (requestParameters['noveltyCalcRequest'] == null) {
            throw new runtime.RequiredError(
                'noveltyCalcRequest',
                'Required parameter "noveltyCalcRequest" was null or undefined when calling rerunNoveltyCalc().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/novelty-calc/{simulationId}/rerun`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters['simulationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NoveltyCalcRequestToJSON(requestParameters['noveltyCalcRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NoveltyCalcResponseFromJSON(jsonValue));
    }

    /**
     * Runs NoveltyCalc again with the given parameters and, only on success, discards the existing PreDraft simulation in favor of the new one. If the new run fails (grouped error entries returned, same shape as Run), the existing PreDraft simulation is left untouched.  **Required Permission(s):** `NoveltyCalculation`
     * Rerun NoveltyCalc
     */
    async rerunNoveltyCalc(requestParameters: RerunNoveltyCalcRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NoveltyCalcResponse> {
        const response = await this.rerunNoveltyCalcRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `WriteSimulations`
     */
    async restoreSimulationFromVersionRaw(requestParameters: RestoreSimulationFromVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling restoreSimulationFromVersion().'
            );
        }

        if (requestParameters['versionId'] == null) {
            throw new runtime.RequiredError(
                'versionId',
                'Required parameter "versionId" was null or undefined when calling restoreSimulationFromVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/{simulationId}/versions/{versionId}/restore`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters['simulationId']))).replace(`{${"versionId"}}`, encodeURIComponent(String(requestParameters['versionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     *   **Required Permission(s):** `WriteSimulations`
     */
    async restoreSimulationFromVersion(requestParameters: RestoreSimulationFromVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.restoreSimulationFromVersionRaw(requestParameters, initOverrides);
    }

    /**
     * Calculates novelty prices for the given price unit and planning year and, on success, persists the results as a new PreDraft simulation. On failure, returns errors grouped by category — each group has a short message and the list of affected products.  **Required Permission(s):** `NoveltyCalculation`
     * Run NoveltyCalc
     */
    async runNoveltyCalcRaw(requestParameters: RunNoveltyCalcRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NoveltyCalcResponse>> {
        if (requestParameters['noveltyCalcRequest'] == null) {
            throw new runtime.RequiredError(
                'noveltyCalcRequest',
                'Required parameter "noveltyCalcRequest" was null or undefined when calling runNoveltyCalc().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/novelty-calc/run`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NoveltyCalcRequestToJSON(requestParameters['noveltyCalcRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NoveltyCalcResponseFromJSON(jsonValue));
    }

    /**
     * Calculates novelty prices for the given price unit and planning year and, on success, persists the results as a new PreDraft simulation. On failure, returns errors grouped by category — each group has a short message and the list of affected products.  **Required Permission(s):** `NoveltyCalculation`
     * Run NoveltyCalc
     */
    async runNoveltyCalc(requestParameters: RunNoveltyCalcRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NoveltyCalcResponse> {
        const response = await this.runNoveltyCalcRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `CreatePrice`
     */
    async saveCreatePriceSessionRaw(requestParameters: SaveCreatePriceSessionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['saveCreatePriceSessionRequest'] == null) {
            throw new runtime.RequiredError(
                'saveCreatePriceSessionRequest',
                'Required parameter "saveCreatePriceSessionRequest" was null or undefined when calling saveCreatePriceSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/create-price-experience/session`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveCreatePriceSessionRequestToJSON(requestParameters['saveCreatePriceSessionRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     *   **Required Permission(s):** `CreatePrice`
     */
    async saveCreatePriceSession(requestParameters: SaveCreatePriceSessionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.saveCreatePriceSessionRaw(requestParameters, initOverrides);
    }

    /**
     *   **Required Permission(s):** `CreatePrice`
     */
    async saveCreatePricesRaw(requestParameters: SaveCreatePricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SaveCreatePriceResponse>> {
        if (requestParameters['saveCreatePriceRequest'] == null) {
            throw new runtime.RequiredError(
                'saveCreatePriceRequest',
                'Required parameter "saveCreatePriceRequest" was null or undefined when calling saveCreatePrices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/create-price-experience/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SaveCreatePriceRequestToJSON(requestParameters['saveCreatePriceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SaveCreatePriceResponseFromJSON(jsonValue));
    }

    /**
     *   **Required Permission(s):** `CreatePrice`
     */
    async saveCreatePrices(requestParameters: SaveCreatePricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SaveCreatePriceResponse> {
        const response = await this.saveCreatePricesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Confirms the PreDraft simulation, transitioning it to Draft using the provided simulationName.  **Required Permission(s):** `NoveltyCalculation`
     * Save NoveltyCalc results
     */
    async saveNoveltyCalcResultsRaw(requestParameters: SaveNoveltyCalcResultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SimulationOperationResult>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling saveNoveltyCalcResults().'
            );
        }

        if (requestParameters['saveNoveltyCalcRequestBody'] == null) {
            throw new runtime.RequiredError(
                'saveNoveltyCalcRequestBody',
                'Required parameter "saveNoveltyCalcRequestBody" was null or undefined when calling saveNoveltyCalcResults().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/novelty-calc/{simulationId}/save`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters['simulationId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SaveNoveltyCalcRequestBodyToJSON(requestParameters['saveNoveltyCalcRequestBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SimulationOperationResultFromJSON(jsonValue));
    }

    /**
     * Confirms the PreDraft simulation, transitioning it to Draft using the provided simulationName.  **Required Permission(s):** `NoveltyCalculation`
     * Save NoveltyCalc results
     */
    async saveNoveltyCalcResults(requestParameters: SaveNoveltyCalcResultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SimulationOperationResult> {
        const response = await this.saveNoveltyCalcResultsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `EditSimulationPrices`
     */
    async savePriceRowsRaw(requestParameters: SavePriceRowsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling savePriceRows().'
            );
        }

        if (requestParameters['savePriceRowsRequestBody'] == null) {
            throw new runtime.RequiredError(
                'savePriceRowsRequestBody',
                'Required parameter "savePriceRowsRequestBody" was null or undefined when calling savePriceRows().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/{simulationId}/save`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters['simulationId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SavePriceRowsRequestBodyToJSON(requestParameters['savePriceRowsRequestBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     *   **Required Permission(s):** `EditSimulationPrices`
     */
    async savePriceRows(requestParameters: SavePriceRowsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.savePriceRowsRaw(requestParameters, initOverrides);
    }

    /**
     *   **Required Permission(s):** `EditSimulationSettings`
     */
    async savePriceSettingsRaw(requestParameters: SavePriceSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling savePriceSettings().'
            );
        }

        if (requestParameters['savePriceSettingsRequestBody'] == null) {
            throw new runtime.RequiredError(
                'savePriceSettingsRequestBody',
                'Required parameter "savePriceSettingsRequestBody" was null or undefined when calling savePriceSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/{simulationId}/price-settings`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters['simulationId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SavePriceSettingsRequestBodyToJSON(requestParameters['savePriceSettingsRequestBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     *   **Required Permission(s):** `EditSimulationSettings`
     */
    async savePriceSettings(requestParameters: SavePriceSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.savePriceSettingsRaw(requestParameters, initOverrides);
    }

    /**
     *   **Required Permission(s):** `AccessTestEndpoints`
     */
    async searchDevDashboardAutoCalcLogsRaw(requestParameters: SearchDevDashboardAutoCalcLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DevAutoCalcLogDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dev/dashboard/autocalc-logs/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DevAutoCalcLogFilterToJSON(requestParameters['devAutoCalcLogFilter']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DevAutoCalcLogDtoFromJSON));
    }

    /**
     *   **Required Permission(s):** `AccessTestEndpoints`
     */
    async searchDevDashboardAutoCalcLogs(requestParameters: SearchDevDashboardAutoCalcLogsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DevAutoCalcLogDto>> {
        const response = await this.searchDevDashboardAutoCalcLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `AccessTestEndpoints`
     */
    async searchDevDashboardBwPricesRaw(requestParameters: SearchDevDashboardBwPricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DevPriceRowDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dev/dashboard/bw-prices/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DevPriceRowFilterToJSON(requestParameters['devPriceRowFilter']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DevPriceRowDtoFromJSON));
    }

    /**
     *   **Required Permission(s):** `AccessTestEndpoints`
     */
    async searchDevDashboardBwPrices(requestParameters: SearchDevDashboardBwPricesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DevPriceRowDto>> {
        const response = await this.searchDevDashboardBwPricesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `AccessTestEndpoints`
     */
    async searchDevDashboardEventInboxRaw(requestParameters: SearchDevDashboardEventInboxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DevEventInboxMessageDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dev/dashboard/event-inbox/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DevEventInboxFilterToJSON(requestParameters['devEventInboxFilter']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DevEventInboxMessageDtoFromJSON));
    }

    /**
     *   **Required Permission(s):** `AccessTestEndpoints`
     */
    async searchDevDashboardEventInbox(requestParameters: SearchDevDashboardEventInboxRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DevEventInboxMessageDto>> {
        const response = await this.searchDevDashboardEventInboxRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `AccessTestEndpoints`
     */
    async searchDevDashboardPriceEventsRaw(requestParameters: SearchDevDashboardPriceEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DevPriceRowDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dev/dashboard/price-events/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DevPriceRowFilterToJSON(requestParameters['devPriceRowFilter']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DevPriceRowDtoFromJSON));
    }

    /**
     *   **Required Permission(s):** `AccessTestEndpoints`
     */
    async searchDevDashboardPriceEvents(requestParameters: SearchDevDashboardPriceEventsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DevPriceRowDto>> {
        const response = await this.searchDevDashboardPriceEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `DeleteSimulations`
     */
    async simulationDeleteRaw(requestParameters: SimulationDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling simulationDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/delete`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     *   **Required Permission(s):** `DeleteSimulations`
     */
    async simulationDelete(requestParameters: SimulationDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.simulationDeleteRaw(requestParameters, initOverrides);
    }

    /**
     *   **Required Permission(s):** `ReadSimulations`
     */
    async simulationListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SimulationListEntryDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SimulationListEntryDtoFromJSON));
    }

    /**
     *   **Required Permission(s):** `ReadSimulations`
     */
    async simulationList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SimulationListEntryDto>> {
        const response = await this.simulationListRaw(initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `WriteSimulations`
     */
    async simulationPublishPricesSimulationIdRaw(requestParameters: SimulationPublishPricesSimulationIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling simulationPublishPricesSimulationId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/publish-prices/{simulationId}`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters['simulationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PublishPricesRequestBodyToJSON(requestParameters['publishPricesRequestBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     *   **Required Permission(s):** `WriteSimulations`
     */
    async simulationPublishPricesSimulationId(requestParameters: SimulationPublishPricesSimulationIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.simulationPublishPricesSimulationIdRaw(requestParameters, initOverrides);
    }

    /**
     *   **Required Permission(s):** `ReadSimulations`
     */
    async simulationSimulationIdRaw(requestParameters: SimulationSimulationIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSimulationResponse>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling simulationSimulationId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/{simulationId}`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters['simulationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSimulationResponseFromJSON(jsonValue));
    }

    /**
     *   **Required Permission(s):** `ReadSimulations`
     */
    async simulationSimulationId(requestParameters: SimulationSimulationIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSimulationResponse> {
        const response = await this.simulationSimulationIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `WriteSimulations`
     */
    async simulationStartRaw(requestParameters: SimulationStartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StartSimulationResponse>> {
        if (requestParameters['startSimulationRequestBody'] == null) {
            throw new runtime.RequiredError(
                'startSimulationRequestBody',
                'Required parameter "startSimulationRequestBody" was null or undefined when calling simulationStart().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/start`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StartSimulationRequestBodyToJSON(requestParameters['startSimulationRequestBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StartSimulationResponseFromJSON(jsonValue));
    }

    /**
     *   **Required Permission(s):** `WriteSimulations`
     */
    async simulationStart(requestParameters: SimulationStartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StartSimulationResponse> {
        const response = await this.simulationStartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `CreatePrice`
     */
    async startCreatePriceExperienceRaw(requestParameters: StartCreatePriceExperienceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CreatePriceExperienceRowDto>>> {
        if (requestParameters['createPriceExperienceRequest'] == null) {
            throw new runtime.RequiredError(
                'createPriceExperienceRequest',
                'Required parameter "createPriceExperienceRequest" was null or undefined when calling startCreatePriceExperience().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/create-price-experience/start`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePriceExperienceRequestToJSON(requestParameters['createPriceExperienceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CreatePriceExperienceRowDtoFromJSON));
    }

    /**
     *   **Required Permission(s):** `CreatePrice`
     */
    async startCreatePriceExperience(requestParameters: StartCreatePriceExperienceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CreatePriceExperienceRowDto>> {
        const response = await this.startCreatePriceExperienceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Copies matching field values from the targets table into existing calculation settings rows for planning years (current and next), joined on PriceUnitId and Year. Only updates existing rows — no new rows are created.  **Required Permission(s):** `WriteCalculationSettings`
     * Sync targets to calculation settings
     */
    async syncTargetsToCalculationSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SyncTargetsToCalculationSettingsResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/calculation-settings/sync-from-targets`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SyncTargetsToCalculationSettingsResultFromJSON(jsonValue));
    }

    /**
     * Copies matching field values from the targets table into existing calculation settings rows for planning years (current and next), joined on PriceUnitId and Year. Only updates existing rows — no new rows are created.  **Required Permission(s):** `WriteCalculationSettings`
     * Sync targets to calculation settings
     */
    async syncTargetsToCalculationSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SyncTargetsToCalculationSettingsResult> {
        const response = await this.syncTargetsToCalculationSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async testRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TestResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/Test`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TestResponseFromJSON(jsonValue));
    }

    /**
     */
    async test(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TestResponse> {
        const response = await this.testRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async themesRaw(requestParameters: ThemesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FilteredListItem>>> {
        if (requestParameters['searchField'] == null) {
            throw new runtime.RequiredError(
                'searchField',
                'Required parameter "searchField" was null or undefined when calling themes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['searchField'] != null) {
            queryParameters['SearchField'] = requestParameters['searchField'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['Limit'] = requestParameters['limit'];
        }

        if (requestParameters['matrixOnly'] != null) {
            queryParameters['MatrixOnly'] = requestParameters['matrixOnly'];
        }

        if (requestParameters['countryOnly'] != null) {
            queryParameters['CountryOnly'] = requestParameters['countryOnly'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/themes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FilteredListItemFromJSON));
    }

    /**
     */
    async themes(requestParameters: ThemesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FilteredListItem>> {
        const response = await this.themesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `ManageLelPrices`
     */
    async triggerAutoCalcRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TriggerAutoCalcResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auto-calc/run`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TriggerAutoCalcResponseFromJSON(jsonValue));
    }

    /**
     *   **Required Permission(s):** `ManageLelPrices`
     */
    async triggerAutoCalc(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TriggerAutoCalcResponse> {
        const response = await this.triggerAutoCalcRaw(initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `WriteCalculationSettings`
     */
    async updateCalculationSettingsRaw(requestParameters: UpdateCalculationSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CalculationSettingsDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateCalculationSettings().'
            );
        }

        if (requestParameters['calculationSettingsRequestBody'] == null) {
            throw new runtime.RequiredError(
                'calculationSettingsRequestBody',
                'Required parameter "calculationSettingsRequestBody" was null or undefined when calling updateCalculationSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/calculation-settings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CalculationSettingsRequestBodyToJSON(requestParameters['calculationSettingsRequestBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CalculationSettingsDtoFromJSON(jsonValue));
    }

    /**
     *   **Required Permission(s):** `WriteCalculationSettings`
     */
    async updateCalculationSettings(requestParameters: UpdateCalculationSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CalculationSettingsDto> {
        const response = await this.updateCalculationSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `AccessTestEndpoints`
     */
    async updateDevDashboardSettingRaw(requestParameters: UpdateDevDashboardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevSettingDto>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling updateDevDashboardSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dev/dashboard/settings/{key}`.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDevSettingRequestToJSON(requestParameters['updateDevSettingRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevSettingDtoFromJSON(jsonValue));
    }

    /**
     *   **Required Permission(s):** `AccessTestEndpoints`
     */
    async updateDevDashboardSetting(requestParameters: UpdateDevDashboardSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevSettingDto> {
        const response = await this.updateDevDashboardSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *   **Required Permission(s):** `ReadSimulations`
     */
    async updateSimulationAssignmentRaw(requestParameters: UpdateSimulationAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling updateSimulationAssignment().'
            );
        }

        if (requestParameters['updateSimulationAssignmentRequestBody'] == null) {
            throw new runtime.RequiredError(
                'updateSimulationAssignmentRequestBody',
                'Required parameter "updateSimulationAssignmentRequestBody" was null or undefined when calling updateSimulationAssignment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/{simulationId}/assignment`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters['simulationId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSimulationAssignmentRequestBodyToJSON(requestParameters['updateSimulationAssignmentRequestBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     *   **Required Permission(s):** `ReadSimulations`
     */
    async updateSimulationAssignment(requestParameters: UpdateSimulationAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateSimulationAssignmentRaw(requestParameters, initOverrides);
    }

    /**
     *   **Required Permission(s):** `WriteSimulations`
     */
    async updateWatchersRaw(requestParameters: UpdateWatchersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['simulationId'] == null) {
            throw new runtime.RequiredError(
                'simulationId',
                'Required parameter "simulationId" was null or undefined when calling updateWatchers().'
            );
        }

        if (requestParameters['updateWatchersRequestBody'] == null) {
            throw new runtime.RequiredError(
                'updateWatchersRequestBody',
                'Required parameter "updateWatchersRequestBody" was null or undefined when calling updateWatchers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/simulation/{simulationId}/watchers`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters['simulationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateWatchersRequestBodyToJSON(requestParameters['updateWatchersRequestBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     *   **Required Permission(s):** `WriteSimulations`
     */
    async updateWatchers(requestParameters: UpdateWatchersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateWatchersRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userMeClaimsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserClaimsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/me/claims`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserClaimsResponseFromJSON(jsonValue));
    }

    /**
     */
    async userMeClaims(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserClaimsResponse> {
        const response = await this.userMeClaimsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async userMeHasPermissionPermissionRaw(requestParameters: UserMeHasPermissionPermissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HasPermissionResponse>> {
        if (requestParameters['permission'] == null) {
            throw new runtime.RequiredError(
                'permission',
                'Required parameter "permission" was null or undefined when calling userMeHasPermissionPermission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/me/has-permission/{permission}`.replace(`{${"permission"}}`, encodeURIComponent(String(requestParameters['permission']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HasPermissionResponseFromJSON(jsonValue));
    }

    /**
     */
    async userMeHasPermissionPermission(requestParameters: UserMeHasPermissionPermissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HasPermissionResponse> {
        const response = await this.userMeHasPermissionPermissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userMePermissionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserPermissionsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/me/permissions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserPermissionsResponseFromJSON(jsonValue));
    }

    /**
     */
    async userMePermissions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserPermissionsResponse> {
        const response = await this.userMePermissionsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async userMeSyncProfileRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SyncContactResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/me/sync-profile`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SyncContactResponseFromJSON(jsonValue));
    }

    /**
     */
    async userMeSyncProfile(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SyncContactResponse> {
        const response = await this.userMeSyncProfileRaw(initOverrides);
        return await response.value();
    }

}
